import { render, staticRenderFns } from "./CartPageCrossSellContentNonModal.vue?vue&type=template&id=04689ee0"
import script from "./CartPageCrossSellContentNonModal.vue?vue&type=script&lang=js"
export * from "./CartPageCrossSellContentNonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports